<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/entries/customers/new')">
          <i class="plus icon"></i> Nova Clínica
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="customers-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="customers-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="shortName" @onRowClick="navToCustomerForm" />

  </div>

</template>

<script>
    
  import CustomerService from "@/services/customer-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "CustomersPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Clínicas",
        service: new CustomerService(),
        attributes: ["id", "shortName", "person", "cgc", "city", "state", "email", "phone"],
        fields: [          
          { prop: "shortName", label: "Nome" },
          { prop: "cgc", label: "CNPJ / CPF", render: (customer) => this.$formatCgc(customer.cgc) },
          { prop: "email", label: "E-mail" },                    
          { prop: "phone", label: "Telefone" },                    
          { prop: "city", label: "Município", render: this.renderCity },
        ],
      }
    },

    methods: {
      
      navToCustomerForm(data) {
        this.$router.push("/entries/customers/" + data.row.id)
      },

      renderCity(customer) {

        if (!customer.city)
          return ""

        return customer.city.trim() + " / " + customer.state
      }
    },
  }

</script>
